angular.module('App.MyAccount.Preference.Ctrl', [])
.controller('PrefernceCtrl', ['$scope', '$rootScope', 'myAccount', '$log', function($scope, $rootScope, myAccount, $log){
    $scope.myAccount.preferences = $scope.myAccount.preferences || {};

    $rootScope.breadcrumbsConfig.links.unshift({
        linkText: i18n['PREFERENCES'],
        link: $scope.jvUrls.admin+'/myaccount/profile.html#/preferences'
    });

    var init = function(){
        myAccount.getPreferences(function(res){
            $scope.myAccount.preferences = res.preferences;
            $scope.myAccount.preferencesCopy = angular.copy(res.preferences);
            $scope.flags.loading = false;
        }, function(err){
            $scope.flags.loading = false;
            $log.error(err);
        });
    };

    $scope.radioPrefChange = function(emaiPreference){
        $scope.myAccount.preferences.change = $scope.myAccount.preferences.change || [];

        if(!emaiPreference.isChanged){
            $scope.myAccount.preferences.change.push(emaiPreference);
            emaiPreference.isChanged = true;
        }else{
            for(var i=0; i<$scope.myAccount.preferences.change.length; i++){
                if($scope.myAccount.preferences.change[i].name === emaiPreference.name){
                    $scope.myAccount.preferences.change[i].status = emaiPreference.status;
                    break;
                }
            }
        }
    };

    $scope.savePreferences = function(){
        $scope.flags.loading = true;
        var data = angular.copy($scope.myAccount.preferences.change);
        var preferences = {
            emailPreferences: data,
            sessionTimeout: $scope.myAccount.preferences.sessionTimeout
        };

        myAccount.savePreferences(preferences, function(res){
            $scope.flags.loading = false;
            if(res.msgInfo === 200){
                $scope.showMsg('MYACCOUNT_EMAIL_PREFS_UPDATED');
                $scope.myAccount.preferences.edit = false;
            }else{
                $scope.$root.error = $scope.i18n.errors['UNABLE_TO_PERFORM'];
            }
            init();
        }, function(err){
            $scope.flags.loading = false;
            $log.error(err);
        });
    };

    $scope.cancelPrefs = function(){
        $scope.myAccount.preferences = angular.copy($scope.myAccount.preferencesCopy);
    };

    init();
}]);